import React, { useState, useEffect, useContext } from 'react';
import axios from './../Api/MainApi';
import MethodsOneContext from './../Contexts/MethodsOne';
import MethodsTwoContext from './../Contexts/MethodsTwo';
import logger from './../Tools/Log';
import  {requaredValid, onlyLettersValid, emailValid, finalizeValid} from './../Tools/Validation';


function Editor(props) {

  let [State, setState] = useState(
    {
      id: 0,
      description: '',
      tag: '',
      firstLoadId: 0,
      errors:{}
    }
  );

  const methodsOneContext = useContext(MethodsOneContext);
  const methodsTwoContext = useContext(MethodsTwoContext);

  useEffect(() => {

    //page with id in url
    if (props.item.id > 0 && State.id != props.item.id && State.firstLoadId != props.item.id) {
      State.firstLoadId = props.item.id;
      getHandler(props.item.id);
     
    }

    //newEvent
    console.log('tof1',props.item);
    console.log('tof1',State);
    if(props.item.pageMode == 'new'){
      props.item.pageMode = '';
      console.log('tof');
        setState( {
          id: 0,
          description: '',
          tag: '',
          firstLoadId: 0,
          errors:{}
        });
    }
  });

  let saveHandler = e => {
    
    e.preventDefault();
    if(handleValidation()){
    logger('Component >>Editor >> Axios{rest/Edit}');
    methodsOneContext.loading();
    axios.post(`rest/Edit`, {
      Id: State.id,
      Description: State.description,
      Tag: State.tag,
      Description2: '',
      Date: null,
      Image: ''
    },
      {
        headers: {
          Authorization: methodsTwoContext.authorizationInfo.state.accessToken
        },

      })
      .then(Response => {
        methodsOneContext.loading();
        alert("ذخیره شد " + Response.data)
      })
      .catch(err => {
        methodsOneContext.loading();
        console.log(err)
      })
    }     
    else {
      //bikhodi vase in ke setstate faal beshe
      setState({...State});
    }
  }

 

  let getHandler = id => {
    methodsOneContext.loading();
    axios.get(`rest/Details/${id}`,
      {
        headers: {
          Authorization: methodsTwoContext.authorizationInfo.state.accessToken
        },

      })
      .then(Response => {
        methodsOneContext.loading();
        methodsOneContext.editUrl(`Events/Edit/${id}`)
        setState(
          {
            id: Response.data.id,
            description: Response.data.description,
            tag: Response.data.tag,
            errors:{}
          }
        )

      })
      .catch(err => {
        console.log(err)
        methodsOneContext.loading();
      })
  }

  let inputHandler = e => {
    State[e.target.name] = e.target.value;
    handleValidation(e.target.name);
    setState({...State,[e.target.name]:e.target.value})
  }

  let handleValidation = (realTimeName)=>{
        requaredValid(State,"tag",realTimeName);
        requaredValid(State,"description",realTimeName);
      return finalizeValid(State.errors);
  }

  return (
    <>
      <div class="send-reply">
        <div class="avatar">
          <div class="image">
            <img src="https://roocket.ir/img/default.png" />
          </div>
        </div>
        <div class="send-reply--main">


          <form onSubmit={saveHandler} id="discuss-form" class="form">

            <div class="roocket-editor">
              <div class="editor-section  space-y-2">
                <textarea value={State.description} onChange={inputHandler} name="description" id="description-discuss" cols="30" rows="10" placeholder="پاسخ خودتون برای این گفتگو را وارد کنید" data-tribute="true" style={{ height: 500, color: "black" }} />
                <div><span class="text-red-600 mr-2">{State.errors["description"]}</span></div>
                <div class="form-group space-y-2">
                  <label class="label-control">تگ : </label>
                  <input type="text" name="tag" value={State.tag} onChange={inputHandler} class="form-control" />
                  <div><span class="text-red-600 mr-2">{State.errors["tag"]}</span></div>
                </div>
              </div>
              <div data-v-0f3f40df="" class="markdown-preview-switch">
                <label data-v-0f3f40df="" class="switch">
                  <input data-v-0f3f40df="" type="checkbox" />
                  <span data-v-0f3f40df="" class="slider round">
                  </span></label>
                <span data-v-0f3f40df="" class="markdown-preview-switch__text">پیش نمایش متن بالا</span>
              </div>
            </div>
            <div class="send-reply--footer">
              <div class="send-reply--note">
                <span class="item">با استفاده از <span> username </span>
                                                و تایپ
                                                <span> @ </span>
                                                میتوانید به کاربر مورد نظر اشاره کنید تا از پیام شما مطلع شود</span>
                <span class="item">برای ارسال بهتر گفتگو بر روی آیکون راهنما در ویرایشگر بالا کلیک کنید</span>
              </div>
              <button type="submit" class="send-reply--submit">ذخیره</button>
            </div>
          </form>


        </div>
      </div>
    </>
  )
}

export default Editor;